<template>
    <div>
        <div
            v-for="(item, index) in list"
            :key="index"
            class="chain"
            :class="{
                completed: item.completed || item.skiped,
                active: item.active,
                clickable: isClickable(item),
                editing: !item.completed && item.active,
                gray: item.tag === 'customer-cadastrado'
            }"
        >
            <div
                class="circle"
                @click="activeThis(item, isClickable(item))"
            >
                <div class="status">
                    <em class="fal fa-check icon" />
                </div>
            </div>
            <div
                :class="{ clickable: isClickable(item) }"
                @click="activeThis(item, isClickable(item))"
            >
                <h3
                    class="title"
                    :class="{ completed: item.completed || item.skiped }"
                >
                    {{ item.name }}
                </h3>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: "ui-chain-menu",

  props: {
    value: {
      type: Array,
      default: () => [],
    },

    clickable: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      list: [],
    }
  },

  watch: {
    value: {
      deep: true,
      handler(newValue) {
        this.list = newValue
      },
    },

    list: {
      deep: true,
      handler(newValue) {
        this.$emit("input", newValue)
      },
    },
  },

  mounted() {
    this.list = this.value
  },

  methods: {
    activeThis(itemToActivate, bool) {
      if (!bool) return

      if (this.clickable) {
        this.list.forEach((item) => {
          if (item === itemToActivate) {
            item.active = true
          } else {
            item.active = false
          }
        })
      }
    },

    isClickable(item) {
      if (item.tag === "customer-cadastrado") return false

      return this.clickable
    },
  },

}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
